import { Directive } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";

@Directive({
  selector: "[mustBeNumber]",
})
export class NumberDirective {
  constructor() {}

  validate(control: UntypedFormControl) {
    if (!control?.value) return null;

    const isNumber = /^[0-9]+$/;

    return isNumber.test(control.value)
      ? null
      : {
          notNumber: true,
        };
  }
}
